var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { readOnly } from '@ember/object/computed';
const GOLDEN_PATH_AUDIENCES_APPOINTMENTS = new Set(['beauty', 'wellness', 'healthcare']);
const GOLDEN_PATH_AUDIENCES_RESTAURANTS = new Set(['complex_qsr', 'fsr', 'bar_brewery_lounge']);
const GOLDEN_PATH_AUDIENCES_RETAIL = new Set(['retail_goods', 'grocery_gourmet_alcohol']);
const GOLDEN_PATH_AUDIENCES = new Set([...GOLDEN_PATH_AUDIENCES_APPOINTMENTS, ...GOLDEN_PATH_AUDIENCES_RESTAURANTS, ...GOLDEN_PATH_AUDIENCES_RETAIL]);
const GOLDEN_PATH_PHASE_1_AUDIENCES = new Set(['simple_qsr', 'business_service', 'maintenance_repair', 'contracting_specialty_trade', 'personal_service', 'creative_design', 'simple_retail_goods', 'complex_retail_goods', 'grocery_gourmet_alcohol', 'beauty', 'fitness', 'wellness', 'healthcare', 'leisure_entertainment', 'transportation', 'casual_use', 'charity_education_membership']);
let GoldenPath = (_dec = readOnly('currentUserData.data'), _class = class GoldenPath extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "currentUserData", _descriptor, this);
    _initializerDefineProperty(this, "data", _descriptor2, this);
    _defineProperty(this, "isGoldenPathEnabled", this.data.mccData?.goldenPathEnabled ?? false);
    _defineProperty(this, "audienceType", this.data.mccData?.audienceType ?? '');
  }
  get isQSR() {
    return this.isGoldenPathEnabled && this.audienceType === 'complex_qsr';
  }
  get isFSR() {
    return this.audienceType === 'fsr';
  }
  get isAppointments() {
    return this.isGoldenPathEnabled && GOLDEN_PATH_AUDIENCES_APPOINTMENTS.has(this.audienceType);
  }
  get isRestaurants() {
    return this.isGoldenPathEnabled && GOLDEN_PATH_AUDIENCES_RESTAURANTS.has(this.audienceType);
  }
  get isRetail() {
    return this.isGoldenPathEnabled && GOLDEN_PATH_AUDIENCES_RETAIL.has(this.audienceType);
  }

  // Home has a different release schedule and audience list than other workstreams
  get isGoldenPathForHome() {
    return this.isGoldenPathEnabled && ['complex_qsr', 'fsr', 'bar_brewery_lounge'].includes(this.audienceType);
  }
  get isGoldenPathAudience() {
    return this.isGoldenPathEnabled && GOLDEN_PATH_AUDIENCES.has(this.audienceType);
  }
  get isGoldenPathPhase1Audience() {
    return GOLDEN_PATH_PHASE_1_AUDIENCES.has(this.audienceType);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "currentUserData", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "data", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { GoldenPath as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your services.